import Vue from 'vue'
import Vuex from 'vuex'
import projectConfig from '../constant/projectConfig'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    id: null,
    from: {},
    userInfo: JSON.parse(localStorage.getItem("userInfo")) || { permissions: [] },
    permissions: JSON.parse(localStorage.getItem('permissions')) || [],// 存储用户权限
    permissionsList: [
      {
        name: "userList",
        path: "/user"

      }, {
        name: "userDetail",
        path: "/userDetail"

      }, {
        name: "feedbackList",
        path: "/feedback"

      }, {
        name: "updateFeedback",

      }, {
        name: "deleteFeedback",

      }, {
        name: "userMap",
        path: "/distribution"

      },
      {
        name: "deviceLists",
        path: "/dev"

      }, {
        name: "projectList",
        path: "/project"

      }, {
        name: "addProject",

      }, {
        name: "updateProject",
      }, {
        name: "deleteProject",

      }, {
        name: "OTAList",
        path: "/ota"

      }, {
        name: "retriveOTA",

      }, {
        name: "addOTA",

      }, {
        name: "updateOTA",

      }, {
        name: "dialList",
        path: "/dial"

      }, {
        name: "addDial",

      }, {
        name: "updateDial",

      }, {
        name: "deleteDial",

      }, {
        name: "adminUserList",
        path: "/member"

      }, {
        name: "addAdminUser",

      }, {
        name: "updateAdminUser",

      }, {
        name: "roleList",
        path: "/role"

      }, {
        name: "addRole",

      }, {
        name: "updateRole",

      }, {
        name: "deleteAdminUser",

      }, {
        name: "deleteRole",

      }, {
        name: "deviceLists",
        path: "/dev"

      }, {
        name: "deviceDetail",
        path: "/devDetail"

      }, {
        name: "repairLogAdd",

      }, {
        name: "deleteRepairLog",

      }, {
        name: "businessList",
        path: "/institution"
      },
      {
        name: "businessAdd",
        path: "/newInstitution"
      }, {
        name: "businessEditConfigure"
      }, {
        name: "businessDetail",
        path: "/institutionDetail"
      }, {
        name: "businessInstitutionList",
        path: "/merchant"
      }, {
        name: "businessInstitutionAdd"
      }, {
        name: "businessInstitutionDelete"
      }
    ]
  },
  mutations: {
    changeFrom(state, data) {
      state.from = data

    },
    changeUserInfo(state, data) {
      state.userInfo = data

    },

    changeId(state, data) {
      state.id = data

    },
    setPermissions(state, permissions) {
      state.permissions = permissions
      localStorage.setItem('permissions', JSON.stringify(permissions));
    }
  },
  getters: {
    isAdmin: state => {
      // return state.userInfo.permissions.length==0
      return state.userInfo.permissions.includes('all')
    },
    permissionsListHander: state => {
      let permissions = state.userInfo.permissions
      //  if(permissions.length==0)return "isAdmin";//旧逻辑
      if (permissions.includes('all')) return "isAdmin";//新逻辑
      // let permissionsList = state.permissionsList.filter(item => {
      //   return item.path && permissions.includes(item.name)
      // })
      function filterPermissions(items, permissions) {
        return items.map(item => {
          const newItem = { ...item }; // 复制当前项
          if (newItem.children) {
            newItem.children = filterPermissions(newItem.children, permissions); // 递归过滤子项
          }
          return newItem; // 返回新的项
        }).filter(item => {
          // 过滤掉没有匹配权限的项（包括其子项）
          return permissions.includes(item.code) || (item.children && item.children.length > 0);
        });
      }

      let permissionsList = filterPermissions(projectConfig.LEFT_MENU, permissions);
      // console.log('permissionsList', permissionsList);
      return permissionsList
    }
  },
  actions: {
    updatePermissions({ commit }, permissions) {
      commit('setPermissions', permissions)
    }
  },
  modules: {

  }
})
